<template>
  <div class="home-page">
    <!-- Navbar -->
    <navbar-home></navbar-home>
    <section class="ew-thankyou-section">
      <div class="ew-smaller-container text-center">
        <div class="ew-inner-container">
          <h3 class="ew-thankyou-title">¡Gracias! ¡Tu mensaje llegó a su destino!</h3>
          <p class="ew-thankyou-subtitle">Pronto un asesor responderá tus inquietudes</p>
        </div>
      </div>
    </section>
    <!-- Footer global -->
    <AppFooter />
  </div>
</template>

<style scoped>
.ew-thankyou-section {
  min-height: 60vh;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  padding: 60px 0;
}

.ew-inner-container {
  background: #fff;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.ew-thankyou-title {
  font-size: 1.8rem;
  color: #2c2e78;
  margin-bottom: 15px;
}

.ew-thankyou-subtitle {
  font-size: 1rem;
  color: #6c6c6c;
}

.ew-social-container {
  margin-top: 30px;
}

.ew-social-text {
  font-weight: 600;
  color: #e80c4a;
  margin-bottom: 15px;
}

.ew-social-icon img {
  width: 40px;
  height: 40px;
  transition: transform 0.2s ease;
}

.ew-social-icon:hover img {
  transform: scale(1.2);
}
</style>

<script>
import AppFooter from "@/components/AppFooter.vue";
import NavbarHome from "@/components/Header/NavbarHome.vue";
export default {
  name: 'ThankPage',
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  },
  computed: {},
  components: {
    AppFooter,
    "navbar-home": NavbarHome
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ThankPage.vue